var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2 21.3c-.9-.6-2.2-.4-2.8.5-2.8 4.1-8 5.8-12.7 4.2-4.5-1.3-7.5-5.3-7.7-10 .1-4.7 3.2-8.7 7.7-10.2 3.5-1.2 7.2-.5 10 1.6H22c-1.1 0-2 .9-2 2s.9 2 2 2h6c1.1 0 2-.9 2-2v-6c0-1.1-.9-2-2-2s-2 .9-2 2V4C22.2 1.3 17.1.4 12.4 2 6.3 3.9 2.1 9.5 1.9 16v.2c.2 6.4 4.4 12 10.5 13.9 1.6.6 3.3.8 4.9.8 4.9 0 9.6-2.4 12.5-6.6.6-1.1.3-2.3-.6-3"
  })));
};
export default SvgRefresh;